module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmYUtfChc4EsA.f31a705d.woff2";